import { useRoutes } from 'react-router-dom';


function Blank() {
  return (<div>Processing login....</div>);
}

export default Blank;
